import { Statistics } from '../api/types/Insights';
import { getRiskIndicatorByRiskRule, RISK_SEVERITY } from '@silverfort-nodelibs/common/utils/insight';

export const countExposuresBySeverity = (insightsStatistics?: Statistics | null): Record<string, number> => {
    const severityCounter = {
        [RISK_SEVERITY.LOW]: 0,
        [RISK_SEVERITY.MEDIUM]: 0,
        [RISK_SEVERITY.HIGH]: 0,
        [RISK_SEVERITY.CRITICAL]: 0
    };

    if (!insightsStatistics) return severityCounter;

    for (const key in insightsStatistics) {
        const entitiesCount = insightsStatistics[key];

        if (entitiesCount > 0) {
            const riskIndicator = getRiskIndicatorByRiskRule(key);

            if (riskIndicator?.severity) {
                severityCounter[riskIndicator.severity] += entitiesCount;
            }
        }
    }

    return severityCounter;
};
